import { render } from "./ToggleBusinessStatusModal.vue?vue&type=template&id=149d2c9d&ts=true"
import script from "./ToggleBusinessStatusModal.vue?vue&type=script&lang=ts"
export * from "./ToggleBusinessStatusModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__